import React, { FC } from "react";

import { Typography } from "design_system/src";
import { ReactComponent as TickCircle } from "design_system/src/static/icons/tick-circle.svg";

import "./PasswordErrorIndicator.scss";

interface PasswordRuleProps {
    label: string;
    valid: boolean;
}

const PasswordRule: React.FC<PasswordRuleProps> = ({
    label,
    valid,
}) => {
    return <div className="password-error display_flex flex_align_start">
        <TickCircle className={`password-error__tick m_t_xxxs${valid ? " active" : ""}`} />
        <div className="flex_grow_1 p_l_sm">
            <Typography weight="400" scale="small">{label}</Typography>
        </div>
    </div>;
};

interface PasswordErrorIndicatorProps {
    value: string;
}

export const PasswordErrorIndicator: FC<PasswordErrorIndicatorProps> = ({
    value
}) => {
    return <div className="password-errors">
        <Typography weight="600" scale="small">Tu contraseña debe contener</Typography>
        <div className="p_x_sm p_y_sm">
            <PasswordRule label="Mínimo 6 caracteres." valid={/^.{6,}$/.test(value)} />
            <PasswordRule label="Máximo 50 caracteres." valid={/^.{1,50}$/.test(value)} />
            <PasswordRule label="Al menos una mayúscula." valid={/[A-Z]/.test(value)} />
            <PasswordRule label="Al menos una minúscula." valid={/[a-z]/.test(value)} />
            <PasswordRule label="Al menos un número." valid={/\d/.test(value)} />
        </div>
    </div>;
};
